import React from "react";
import s from "./MessagingMeta.module.scss";
import { Skeleton } from "antd";
type PropType = {
  failures: string;
  avgDuration: string;
  loading: boolean;
};
function VoiceMeta({
  failures,
  loading,

  avgDuration,
}: PropType) {
  if (loading) {
    return (
      <div className={s.wrapper}>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
      </div>
    );
  }
  return (
    <div className={s.wrapper}>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Failures</h5>
        <p className={s.statNumber}>{failures.toLocaleString()}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Average duration</h5>
        <p className={s.statNumber}>{avgDuration}</p>
      </div>
    </div>
  );
}

export default VoiceMeta;
